import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';

interface TripeDiscountCouponBottomSheetProps {}

const TripeDiscountCouponBottomSheet: FC<TripeDiscountCouponBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <NolNoticeBottomSheet
      title={'할인쿠폰 유의사항'}
      isOpen={store.isTripleDiscountCouponBottomSheetOpen}
      onRequestClose={() => (store.isTripleDiscountCouponBottomSheetOpen = false)}
    >
      <strong>※ 이벤트 기간: {store.eventNolCouponPeriod}</strong>
      <ul>
        <li>
          할인 쿠폰의 할인비율과 최소 결제 금액 조건은 상품 판매가(포인트 미적용 금액)를 기준으로 하며, NOL 카드페이에
          등록된 NOL 카드로 결제 시에만 NOL 쿠폰을 사용 가능
        </li>
        <li>
          NOL 카드 페이 가입 및 NOL 카드와 연동 후 30일 이내 트리플에 회원 가입 완료한 경우 쿠폰 지급 및 이용 가능
        </li>
        <li>상세 내용은 페이지 하단의 유의사항 참조</li>
        <li>트리플에서 제공하는 NOL 쿠폰의 상세 안내는 트리플에서 확인 가능</li>
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(TripeDiscountCouponBottomSheet);
